/**
 * Heading size to help manage sticky element
 * If any change are made, dont forget to impact: config/_variables.scss
 */
export const headerHeight = 16.5;
export const headerHeightM = 11.5;
export const headerHeightXS = 10.4;
export const headerHeightScrolled = 6.6;
export const headerHeightScrolledM = 7.5;
export const headerHeightScrolledXS = 5.5;
